import { PlaceAutocompleteOnSelectArgs } from '../PlacesAutocomplete.types';

import { adaptAddressComponentsToResponse } from './adaptAddressComponentsToResponse';

interface PlaceAddressComponent {
  longText?: string;
  shortText?: string;
  types: string[];
}

interface PlaceLocation {
  lat: number | (() => number);
  lng: number | (() => number);
}

const readCoordinate = (value: number | (() => number)): number => {
  return typeof value === 'function' ? value() : value;
};

export const adaptPlaceDetailsToResponse = ({
  addressComponents,
  location,
  address,
}: {
  addressComponents?: PlaceAddressComponent[];
  location?: PlaceLocation;
  address: string;
}): PlaceAutocompleteOnSelectArgs => {
  const parsed = adaptAddressComponentsToResponse({
    address,
    components: (addressComponents ?? []).map((component) => ({
      longName: component.longText ?? '',
      shortName: component.shortText ?? '',
      types: component.types,
    })),
  });

  if (!location) {
    return parsed;
  }

  return {
    ...parsed,
    latitude: readCoordinate(location.lat),
    longitude: readCoordinate(location.lng),
  };
};
